import { Controller } from "@hotwired/stimulus"

// Add-contact heads-up: before adding a team contact, ask the server whether
// the typed phone already belongs to a contact under another client. If so,
// confirm with the operator (a heads-up, never a block: a shared manager
// repping several artists is a real and allowed case). On confirm, or when
// there is no phone / no match / a lookup error, the form submits normally.
//
// The controller sits on a WRAPPER element (edit page): the phone target
// lives in the Team Contacts card while the submit action fires on the
// contact-add carrier form, so the form is taken from the event, never from
// this.element. The confirm rides window.appConfirm, the ONE app modal
// (owner directive 2026-08-13: no browser confirm()).
export default class extends Controller {
  static values = { url: String }
  static targets = ["phone"]

  async check(event) {
    if (this.confirmed) { this.confirmed = false; return } // second pass: let it submit
    const form = event.target
    const phone = this.hasPhoneTarget ? this.phoneTarget.value.trim() : ""
    if (!phone) return // no number to check

    event.preventDefault()
    let matches = []
    try {
      const res = await fetch(`${this.urlValue}?phone=${encodeURIComponent(phone)}`,
                              { headers: { Accept: "application/json" } })
      const body = await res.json()
      matches = body.matches || []
    } catch (e) {
      // A lookup failure must never block a legitimate add.
    }

    if (matches.length) {
      const who = matches.map((m) => `${m.contact_name} (${m.client_name})`).join(", ")
      const ok = await window.appConfirm(
        `This number is already on file for ${who}. Add them to this client's texting thread too?`,
        { confirmLabel: "Add Contact" }
      )
      if (!ok) return // operator declined; leave the form as-is
    }

    this.confirmed = true
    form.requestSubmit()
  }
}
